import { Interjection } from '../../types'

const бля: Interjection = {
  type: 'interjection',
  interjection: 'бля',
}

export default бля
